<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="650" persistent scrollable>
    <v-card rounded="xl">
      <v-card-title class="text-h6 font-weight-bold pt-5 px-6">
        Facturar Orden
      </v-card-title>
      <v-card-text class="px-6" style="max-height: 70vh; overflow-y: auto">
        <p class="body-2 mb-4">
          Se creará una factura PPD para esta orden. Los datos fiscales del miembro se cargan automáticamente.
        </p>
        <v-form ref="form" v-model="formValid">
          <v-text-field
            v-model="fiscalData.legalName"
            label="Razón Social *"
            filled rounded dense
            :rules="[v => !!v || 'Requerido']"
          />
          <v-text-field
            v-model="fiscalData.taxId"
            label="RFC *"
            filled rounded dense
            :rules="[v => !!v || 'Requerido']"
          />
          <v-select
            v-model="fiscalData.rf"
            :items="fiscalRegimenItems"
            label="Régimen Fiscal *"
            filled rounded dense
            :rules="[v => !!v || 'Requerido']"
          />
          <v-text-field
            v-model="fiscalData.zipCode"
            label="Código Postal *"
            filled rounded dense
            :rules="[v => !!v || 'Requerido']"
          />
          <v-text-field
            v-model="fiscalData.street"
            label="Calle"
            filled rounded dense
          />
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                v-model="fiscalData.exterior"
                label="Número Exterior"
                filled rounded dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="fiscalData.interior"
                label="Número Interior"
                filled rounded dense
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="fiscalData.neighborhood"
            label="Colonia"
            filled rounded dense
          />
          <v-row dense>
            <v-col cols="6">
              <v-text-field
                v-model="fiscalData.municipality"
                label="Municipio / Alcaldía"
                filled rounded dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="fiscalData.state"
                label="Estado"
                filled rounded dense
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="fiscalData.email"
            label="Email para factura"
            filled rounded dense
          />
          <v-select
            v-model="use"
            :items="usoCFDIItems"
            label="Uso de CFDI"
            filled rounded dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text rounded color="grey darken-1" @click="close" :disabled="loading">
          Cancelar
        </v-btn>
        <v-btn
          :color="color.primary"
          rounded
          class="white--text font-weight-bold"
          @click="submit"
          :loading="loading"
          :disabled="!formValid"
        >
          Facturar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Endpoints from "@/share/Endpoints";
import { colors } from "@/constants/colors.js";
import { fiscalRegimenItems, UsoCFDIItems } from "@/utils/fiscalRegimen";
import { mapMutations } from "vuex";

export default {
  props: {
    value: { type: Boolean, default: false },
    order: { type: Object, default: null },
  },
  data: () => ({
    color: colors,
    formValid: false,
    loading: false,
    fiscalRegimenItems,
    usoCFDIItems: UsoCFDIItems,
    fiscalData: {
      legalName: "",
      taxId: "",
      rf: null,
      zipCode: "",
      street: "",
      exterior: "",
      interior: "",
      neighborhood: "",
      municipality: "",
      state: "",
      email: "",
    },
    use: "G03",
  }),
  watch: {
    value(open) {
      if (open && this.order) {
        const member = this.order.member || {};
        const fd = member.fiscalData || {};
        this.fiscalData = {
          legalName: fd.legalName || "",
          taxId: fd.taxId || "",
          rf: fd.rf || null,
          zipCode: fd.zipCode || "",
          street: fd.street || "",
          exterior: fd.exterior || "",
          interior: fd.interior || "",
          neighborhood: fd.neighborhood || "",
          municipality: fd.municipality || "",
          state: fd.state || "",
          email: fd.email || this.order.email || "",
        };
      }
    },
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    close() {
      this.$emit("input", false);
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const url = Endpoints.invoicesOrderCreate.replace(/:orderId/, this.order.id);
        const { data } = await this.axios.post(url, {
          fiscalData: this.fiscalData,
          use: this.use,
        });
        this.show({ text: data.message || "Factura creada exitosamente", color: "success", time: 3000 });
        this.$emit("invoiced");
        this.close();
      } catch (error) {
        const msg = error.response?.data?.error?.message || "Error al crear la factura";
        this.show({ text: msg, color: "error", time: 4000 });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
